import script from "./CustomNodeLCAStart.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomNodeLCAStart.vue?vue&type=script&setup=true&lang=js"

import "./CustomNodeLCAStart.vue?vue&type=style&index=0&id=5144959b&lang=css"

const __exports__ = script;

export default __exports__